import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ProjectMembersPanel from "./ProjectMembersPanel";

const ProjectMembers = ({ org_id, project_id }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-1"
        onClick={() => setOpen(true)}
      >
        <GroupOutlinedIcon sx={{ fontSize: 18 }} />
        Manage Project Members
      </button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle sx={{ pb: 1 }}>
          Project Members
        </DialogTitle>
        <DialogContent dividers sx={{ pt: 2 }}>
          <ProjectMembersPanel
            org_id={org_id}
            project_id={project_id}
            open={open}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setOpen(false)} variant="contained">
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProjectMembers;
